export function reloadCurrentDocument(): void {
  window.location.reload();
}
